module.exports = __webpack_public_path__ + "img/sld_vcb_ta1_ba1_hor.4ba02724.svg";